import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf12a57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "ceci-header" }
const _hoisted_3 = { class: "condition-area" }
const _hoisted_4 = { class: "ceci-list-container" }
const _hoisted_5 = { style: {"flex":"auto"} }

import SelectOptions from '@/components/common/SelectOptions.vue'
import { computed, markRaw, ref } from 'vue'
import CourseList from '@/views/course/Course.vue'
import CeciList from '@/views/course/CeciList.vue'
import { CeciConfig } from '@/types'
import { ElMessageBox } from 'element-plus/lib'
import { WarningFilled } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import router from '@/router'

interface SelectOptionsType {
  selectCodes?: {
    [key: string]: any;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const singleSelect = ref<SelectOptionsType | null>(null)
const multipleSelect = ref<SelectOptionsType | null>(null)
const currentCeci = ref<CeciConfig>()
const ceciDrawer = ref(false)

// 计算 ceciTags 数组
const ceciTags = computed(() => {
  if (!currentCeci.value) return []
  return [
    currentCeci.value.platform,
    currentCeci.value.period,
    currentCeci.value.grade,
    currentCeci.value.term
  ].filter(Boolean) // 过滤掉值为 null 或 undefined 的项
})

const ceciId = ref(0)

// Use the useRoute() to access route parameters
const route = useRoute()

// Accessing the specific parameter you need
const routeId = route.params.id // Assuming 'id' is a route parameter

const handleCurrentCeci = (newValue: CeciConfig) => {
  router.push({
    name: 'CourseDetail',
    params: { id: newValue.id }
  })
  currentCeci.value = newValue || null
  ceciDrawer.value = false
}

const handleSingleSelectChange = (selectedValue: SelectOptionsType) => {
  singleSelect.value = selectedValue
  ceciId.value = 0
}

const handleMultipleSelectChange = (selectedValue: SelectOptionsType) => {
  multipleSelect.value = selectedValue
  ceciId.value = 0
}

const handleClose = () => {
  ElMessageBox.alert('请选择册次信息！', {
    type: 'warning',
    icon: markRaw(WarningFilled)
  })
    .then(() => {
      // done()
    })
    .catch(() => {
      // catch error
    })
}

function cancelClick () {
  ceciDrawer.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (ceciDrawer.value=true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("切换册次")
        ]),
        _: 1
      }),
      _createVNode(_component_el_text, { type: "primary" }, {
        default: _withCtx(() => [
          _createTextVNode("当前册次：" + _toDisplayString(currentCeci.value?.title || '未选择，请点击选择'), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ceciTags.value, (tag, index) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          key: index,
          class: "ceci-tag",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tag), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: ceciDrawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ceciDrawer).value = $event)),
      "before-close": handleClose,
      direction: "ltr",
      size: "75%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: cancelClick }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SelectOptions, {
            multiple: false,
            codesIn: "period,subject",
            onChangeSelect: handleSingleSelectChange
          }),
          _createVNode(SelectOptions, {
            multiple: true,
            codesIn: "platform,edition,grade,term",
            onChangeSelect: handleMultipleSelectChange
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CeciList, {
            ceci_id: ceciId.value,
            multipleSelect: multipleSelect.value,
            singleSelect: singleSelect.value,
            onChange: handleCurrentCeci
          }, null, 8, ["ceci_id", "multipleSelect", "singleSelect"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CourseList, {
      ceci: currentCeci.value?.id || _unref(routeId) || 0
    }, null, 8, ["ceci"])
  ]))
}
}

})